/**
 * API configuration
 * Contains all API endpoints and URL builders
 */

export const STORAGE_BASE_URL = "https://firebasestorage.googleapis.com/v0/b/collegiate-nfl-impact.appspot.com/o";

/**
 * Builds the URL for fetching season data from Firebase Storage
 * @param year - The year to fetch data for
 * @param isCurrentSeason - Whether this is the current/ongoing season
 * @returns The full URL to fetch the data
 */
export const getSeasonDataUrl = (year: number, isCurrentSeason: boolean = false): string => {
  const folder = isCurrentSeason ? "season_current" : "season_complete";
  const encodedYear = encodeURIComponent(year);
  return `${STORAGE_BASE_URL}/${folder}%2F${encodedYear}.json?alt=media`;
};

/**
 * Public class-comparison summary (2010–current). Gzipped on Storage; fetch() decodes it.
 * In local development, serve a copy from public/summary/ if present.
 */
export const getClassSummaryUrl = (fromYear: number, toYear: number): string => {
  const fileName = `players_${fromYear}-${toYear}.json`;
  if (process.env.NODE_ENV === "development") {
    return `/summary/${fileName}`;
  }
  return `${STORAGE_BASE_URL}/summary%2F${encodeURIComponent(fileName)}?alt=media`;
};

/**
 * Storage bucket name
 */
export const STORAGE_BUCKET = "collegiate-nfl-impact.appspot.com";




